import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import Icon, { ICONSIZE } from 'presentation/components/Icon';
import checkmarkIcon from 'presentation/assets/icons/svg/checkmark-small.svg';
import bannerImage from 'presentation/assets/images/handshake_small.jpeg';
import { TechemTheme } from '@techem/techem-theme';

const ProviderTransferModalContent: React.FC<any> = () => {
  const { t } = useTranslation();
  return (
    <div className="pb-3">
      <img src={bannerImage} alt="shaking hands" className="mw-100 h-auto" />

      <p className="copy my-4">{t('providerTransferModalDesc')}</p>

      <h4>{t('providerTransferModalListTitle')}</h4>

      {[1, 2, 3].map((advantage) => (
        <Row key={advantage} className="mb-3">
          <Col xs="auto" className="align-self-top ps-md-5 pe-0">
            <Icon
              className="mt-1"
              iconSrc={checkmarkIcon}
              size={ICONSIZE.large}
              alt="checkmark icon"
            ></Icon>
          </Col>
          <Col>
            <span className="copy-l mb-1 d-block" style={{ color: TechemTheme.colors.primaryA }}>
              {t(`providerTransferModalListItem${advantage}Title`)}
            </span>
            <span className="copy">{t(`providerTransferModalListItem${advantage}Desc`)}</span>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default ProviderTransferModalContent;
